import "./assets/globals.less"
import { createApp } from "vue"
import { createPinia } from "pinia"
import { Capacitor } from "@capacitor/core"
// import { App as CapacitorApp } from "@capacitor/app"
import * as Sentry from "@sentry/vue"

import App from "./App.vue"
import router from "./router"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import "swiper/swiper-bundle.css"
import "vue-cal/dist/vuecal.css"
import "sweetalert2/dist/sweetalert2.min.css"
// import "bootstrap/dist/js/bootstrap.bundle.js"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { isOnline } from "./utils/networkBus"
import getURL from "./utils/url"

const CACHE_NAME = "my-cache-v1"

// Keep a reference to the original fetch
const originalFetch = window.fetch

// Override the global fetch
window.fetch = async (input, init) => {
	let requestUrl = typeof input === "string" ? input : input.url

	// Determine the HTTP method (default is GET if not specified)
	const requestMethod =
		init?.method ?? (typeof input === "string" ? "GET" : input.method)
	const method = requestMethod ? requestMethod.toUpperCase() : "GET"
	const skipCache =
		init?.cache === "no-store" ||
		(typeof input !== "string" && input.cache === "no-store")

	// Intercept only if the request includes "/api"
	const shouldIntercept = requestUrl.startsWith("/api")

	if (shouldIntercept) {
		// If on native platform, rewrite URL (e.g., replace '/api' with local IP)
		if (Capacitor.isNativePlatform()) {
			// // if (Capacitor.DEBUG) {
			// // 	requestUrl = requestUrl.replace("/api", "http://192.168.0.93:8788/api")
			// // } else {
			// requestUrl = requestUrl.replace("/api", "https://grubvision.com/api")
			// // }
			requestUrl = requestUrl.replace("/api", getURL("fetch"))
			if (typeof input === "string") {
				input = requestUrl
			} else {
				input.url = requestUrl
			}
		}

		if (method === "GET") {
			try {
				// console.log("[Intercepted fetch]", requestUrl)

				// If offline, try returning a cached response
				if (!skipCache && !isOnline.value && "caches" in window) {
					const cache = await caches.open(CACHE_NAME)
					const cachedResponse = await cache.match(requestUrl, init)
					if (cachedResponse) {
						// console.log("[Using cached response]", requestUrl)
						return cachedResponse
					}
					// If no cache and offline, you might optionally return a fallback.
					// return new Response("Offline", { status: 503 });
				}

				// console.log("[Using network]", requestUrl)

				// Otherwise, do the real network request
				const networkResponse = await originalFetch(input, init)

				// Optionally cache it if the response is OK
				if (
					!skipCache &&
					networkResponse &&
					networkResponse.ok &&
					"caches" in window
				) {
					const responseClone = networkResponse.clone()
					const cache = await caches.open(CACHE_NAME)
					await cache.put(requestUrl, responseClone)
				}

				return networkResponse
			} catch (error) {
				console.error("[Fetch Intercept Error]", error, requestUrl)
				// Optionally return a fallback response if the network fails
				// return new Response("Network Error", { status: 502 });
				throw error
			}
		} else {
			// 4) For non-GET/OPTIONS methods (e.g. POST, PUT, DELETE, PATCH),
			//    simply do the original network call without caching
			// console.log(
			// 	"[Intercepted fetch, but ignoring caching]",
			// 	requestUrl,
			// 	method
			// )
			// alert(requestUrl)
			return originalFetch(input, init)
		}
	}

	// If this request doesn't match "/api", just pass it through
	return originalFetch(input, init)
}

// if (Capacitor.isNativePlatform()) {
// 	initialize()
// }


const app = createApp(App)

// Sentry.init({
// 	app,
// 	dsn: "https://f42d3e961054603100fed157f501f960@o4508877374029824.ingest.us.sentry.io/4508877380452352",
// 	integrations: [
// 		Sentry.browserTracingIntegration({ router }),
// 		Sentry.replayIntegration(),
// 	],
// 	// Tracing
// 	tracesSampleRate: 1.0, //  Capture 100% of the transactions
// 	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// 	tracePropagationTargets: ["localhost", /^https:\/\/grubvision\.com\/api/],
// 	// Session Replay
// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

app.use(createPinia())
app.use(router)

app.mount("#app")
